import {
  BabaSpecialOffer,
  BagelCodeSpecialOffer,
  BanditosSpecialOffer,
  BeachbumSpecialOffer,
  BingoPopSpecialOffer,
  CandyCrushSpecialOffer,
  CashFrenzySpecialOffer,
  CashmanCasinoSpecialOffer,
  ClassicVegasSlotsSpecialOffer,
  CookingMadnessSpecialOffer,
  DecaSpecialOffer,
  DefaultStudioSpecialOffer,
  DoubleHitCasinoSpecialOffer,
  DrimageSpecialOffer,
  FabelTownSpecialOffer,
  HeartOfVegasSpecialOffer,
  HugeSpecialOffer,
  JunesJourneySpecialOffer,
  KonamiSlotsSpecialOffer,
  LightningLinkCasinoSpecialOffer,
  LoadCompleteSpecialOffer,
  LocoBingoSpecialOffer,
  MatchMastersSpecialOffer,
  MightyFuSpecialOffer,
  PipaSpecialOffer,
  PokerFaceSpecialOffer,
  ProductMadnessSpecialOffer,
  SpinXSpecialOffer
} from '@appcharge/shared-ui';
import { ESpecialOfferInternalViewModel } from 'constants/enums';

import { EThemes } from '../enums';

import { PromotionDesignsMetadata } from './types';

const dynamic: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.STUDIO_DEFAULT,
  theme: EThemes.ROYAL_BLAST,
  version: '1.0.0',
  name: 'Dynamic Offer',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: false,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/promotions/promotion_default_subs.png',
    'https://media.appcharge.com/defaults/template-studio/promotions/promotion_default_main.png',
    'https://media.appcharge.com/defaults/template-studio/promotions/promotion_default_main_sub.png'
  ],
  maxPreviewProducts: 1000,
  component: DefaultStudioSpecialOffer
};

// todo: remove!!!!!!!
// const defaultHuuugeNew: PromotionDesignsMetadata = {
//   id: 'huuuge-new',
//   theme: EThemes.HUUUGE,
//   version: '1.0.0',
//   name: 'Huuuge',
//   createdAt: '2025-10-28T08:37:11.255Z',
//   isPrivate: true,
//   previewAssets: [
//     'https://media.appcharge.com/defaults/template-studio/bundles/bundle_default_linear_subs.png',
//     'https://media.appcharge.com/defaults/template-studio/bundles/bundle_default_linear_main.png',
//     'https://media.appcharge.com/defaults/template-studio/bundles/bundle_default_linear_main_sub.png'
//   ],
//   maxPreviewProducts: 1000,
//   component: HugeSpecialOffer
// };

const defaultHuuuge: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.HUGE,
  theme: EThemes.HUUUGE,
  version: '1.0.0',
  name: 'Huuuge',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/promotions/promotion_huuugee.png'
  ],
  maxPreviewProducts: 1000,
  component: HugeSpecialOffer
};

const defaultPlaydogsoft: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.HUGE,
  theme: EThemes.PLAYDOG,
  version: '1.0.0',
  name: 'Playdog',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/promotions/promotion_huuugee.png'
  ],
  maxPreviewProducts: 1000,
  component: HugeSpecialOffer
};

const defaultMatchMasters: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.MATCH_MASTERS,
  theme: EThemes.CANDIVORE,
  version: '1.0.0',
  name: 'Match Masters',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [],
  maxPreviewProducts: 50,
  component: MatchMastersSpecialOffer
};

const defaultPokerFace: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.POKER_FACE,
  theme: EThemes.COMMUNIX,
  version: '1.0.0',
  name: 'Poker Face',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/promotions/promotion_pokerface.png'
  ],
  maxPreviewProducts: 4,
  component: PokerFaceSpecialOffer
};

const defaultCookingMadness: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.COOKING_MADNESS,
  theme: EThemes.TRIPLEDOT,
  version: '1.0.0',
  name: 'Cooking Madness',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/promotions/promotion_cookie_madness.png'
  ],
  maxPreviewProducts: 12,
  component: CookingMadnessSpecialOffer
};

const defaultBagelcode: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.BAGELCODE,
  theme: EThemes.BAGELCODE,
  version: '1.0.0',
  name: 'Bagelcode',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/promotions/promotion_club_vegas.png'
  ],
  maxPreviewProducts: 4,
  component: BagelCodeSpecialOffer
};

const defaultLocobingo: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.LOCO_BINGO,
  theme: EThemes.LOCO_BINGO,
  version: '1.0.0',
  name: 'Loco Bingo',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/promotions/promotion_locobingo.png'
  ],
  maxPreviewProducts: 2,
  component: LocoBingoSpecialOffer
};

// const defaultMe2on: PromotionDesignsMetadata = {
//   id: ESpecialOfferInternalViewModel.ME2ON,
//   theme: EThemes.ME2ON,
//   version: '1.0.0',
//   name: 'Me2on',
//   createdAt: '2025-08-28T08:37:11.255Z',
//   isPrivate: true,
//   previewAssets: [],
//   maxPreviewProducts: 1,
//   component: Me2onSpecialOffer
// };

const defaultPipa: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.PIPA,
  theme: EThemes.PIPA,
  version: '1.0.0',
  name: 'Pipa',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [],
  maxPreviewProducts: 4,
  component: PipaSpecialOffer
};

const defaultJackpotSlots: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.JACKPOT_SLOTS,
  theme: EThemes.PM_Franchise,
  version: '1.0.0',
  name: 'Jackpot Magic Slots',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/promotions/promotion_jms.png'
  ],
  maxPreviewProducts: 20,
  component: ProductMadnessSpecialOffer
};

const defaultBigFishCasino: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.BIG_FISH_CASINO,
  theme: EThemes.PM_Franchise,
  version: '1.0.0',
  name: 'Big Fish Casino',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/promotions/promotion_bfc.png'
  ],
  maxPreviewProducts: 10,
  component: ProductMadnessSpecialOffer
};

const defaultMightyFu: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.MIGHTY_FU,
  theme: EThemes.MIGHTY_FU_CASINO,
  version: '1.0.0',
  name: 'Mighty Fu',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/promotions/promotion_mfc.png'
  ],
  maxPreviewProducts: 10,
  component: MightyFuSpecialOffer
};

const defaultBaba: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.BABA,
  theme: EThemes.BABA,
  version: '1.0.0',
  name: 'Baba',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/promotions/promotion_baba.png'
  ],
  maxPreviewProducts: 9,
  component: BabaSpecialOffer
};

// const defaultPlaySimple: PromotionDesignsMetadata = {
//   id: ESpecialOfferInternalViewModel.PLAY_SIMPLE,
//   theme: EThemes.PLAY_SIMPLE,
//   version: '1.0.0',
//   name: 'Play Simple',
//   createdAt: '2025-08-28T08:37:11.255Z',
//   isPrivate: true,
//   previewAssets: [],
//   maxPreviewProducts: 1,
//   component: PlaySimpleSpecialOffer
// };

const defaultGhost: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.GHOST,
  theme: EThemes.GHOST,
  version: '1.0.0',
  name: 'Classic Vegas Slots',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/promotions/promotion_ghost.png'
  ],
  maxPreviewProducts: 2,
  component: ClassicVegasSlotsSpecialOffer
};

const defaultGhostDoubleHit: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.GHOST_DOUBLE_HIT_CASINO,
  theme: EThemes.GHOST,
  version: '1.0.0',
  name: 'Double Hit Casino',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/promotions/promotion_ghost.png'
  ],
  maxPreviewProducts: 2,
  component: DoubleHitCasinoSpecialOffer
};

const defaultBingoPop: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.BINGO_POP,
  theme: EThemes.BINGO_POP,
  version: '1.0.0',
  name: 'Bingo Pop',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/promotions/promotion_bingo_pop.png'
  ],
  maxPreviewProducts: 7,
  component: BingoPopSpecialOffer
};

const defaultFabelTown: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.FABEL_TOWN,
  theme: EThemes.FABEL_TOWN,
  version: '1.0.0',
  name: 'Fabel Town',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/promotions/promotion_fable_town.png'
  ],
  maxPreviewProducts: 10,
  component: FabelTownSpecialOffer
};

const defaultDeca: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.DECA,
  theme: EThemes.DECA,
  version: '1.0.0',
  name: 'Deca',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [],
  maxPreviewProducts: 40,
  component: DecaSpecialOffer
};

const defaultLoadComplete: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.LOAD_COMPLETE,
  theme: EThemes.LOAD_COMPLETE,
  version: '1.0.0',
  name: 'Load Complete',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/promotions/promotion_loadcomplete.png'
  ],
  maxPreviewProducts: 10,
  component: LoadCompleteSpecialOffer
};

const defaultSpinX: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.SPIN_X,
  theme: EThemes.SPIN_X,
  version: '1.0.0',
  name: 'Spin X',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [],
  maxPreviewProducts: 4,
  component: SpinXSpecialOffer
};

const defaultCashFrenzy: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.CASH_FRENZY,
  theme: EThemes.CASH_FRENZY,
  version: '1.0.0',
  name: 'Cash Frenzy',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [],
  maxPreviewProducts: 5,
  component: CashFrenzySpecialOffer
};

const defaultGennmu: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.GENNMU,
  theme: EThemes.GENNMU,
  version: '1.0.0',
  name: 'Gennmu',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [],
  maxPreviewProducts: 50,
  component: MatchMastersSpecialOffer
};

const defaultBanditos: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.BANDITOS,
  theme: EThemes.BANDITOS,
  version: '1.0.0',
  name: 'Banditos',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/promotions/promotion_banditos.png'
  ],
  maxPreviewProducts: 8,
  component: BanditosSpecialOffer
};

const defaultJunesJourney: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.JUNES_JOURNEY,
  theme: EThemes.JUNES_JOURNEY,
  version: '1.0.0',
  name: 'Junes Journey',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/promotions/promotion_wooga.png'
  ],
  maxPreviewProducts: 8,
  component: JunesJourneySpecialOffer
};

const defaultCandyCrush: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.CANDY_CRUSH,
  theme: EThemes.KING,
  version: '1.0.0',
  name: 'Candy Crush',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/king/promotion-king.png'
  ],
  maxPreviewProducts: 4,
  component: CandyCrushSpecialOffer
};

const defaultBeachbum: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.BEACHBUM,
  theme: EThemes.BEACHBUM,
  version: '1.0.0',
  name: 'Beachbum',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/king/promotion-king.png' // update image for each template
  ],
  maxPreviewProducts: 4,
  component: BeachbumSpecialOffer
};

const defaultKonamiSlots: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.KONAMI_SLOTS,
  theme: EThemes.PLAYSTUDIOS,
  version: '1.0.0',
  name: 'Konami Slots',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/Playstudios/promotion-konami-slots-2.png'
  ],
  maxPreviewProducts: 9,
  component: KonamiSlotsSpecialOffer
};

const defaultDrimage: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.DRIMAGE,
  theme: EThemes.DRIMAGE,
  version: '1.0.0',
  name: 'Drimage',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/promotions/promotion_drimage.png'
  ],
  maxPreviewProducts: 1,
  component: DrimageSpecialOffer
};

const defaultCashmanCasino: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.CASHMAN_CASINO,
  theme: EThemes.CASHMAN_CASINO,
  version: '1.0.0',
  name: 'Cashman Casino',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/promotions/promotion_cmc.png'
  ],
  maxPreviewProducts: 1,
  component: CashmanCasinoSpecialOffer
};

const defaultLightningLinkCasino: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.LIGHTNING_LINK_CASINO,
  theme: EThemes.LIGHTNING_LINK_CASINO,
  version: '1.0.0',
  name: 'Lightning Link Casino',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/promotions/promotion_cmc.png'
  ],
  maxPreviewProducts: 1,
  component: LightningLinkCasinoSpecialOffer
};

const defaultHeartOfVegas: PromotionDesignsMetadata = {
  id: ESpecialOfferInternalViewModel.HEART_OF_VEGAS,
  theme: EThemes.HEART_OF_VEGAS,
  version: '1.0.0',
  name: 'Heart Of Vegas',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/promotions/promotion_cmc.png'
  ],
  maxPreviewProducts: 1,
  component: HeartOfVegasSpecialOffer
};

export const promotionDesigns = {
  defaultHuuuge,
  // defaultHuuugeNew,
  defaultPlaydogsoft,
  defaultMatchMasters,
  defaultPokerFace,
  defaultBagelcode,
  defaultLocobingo,
  defaultPipa,
  defaultJackpotSlots,
  defaultBigFishCasino,
  defaultMightyFu,
  defaultBaba,
  defaultGhost,
  defaultGhostDoubleHit,
  defaultBingoPop,
  defaultFabelTown,
  defaultDeca,
  defaultLoadComplete,
  defaultSpinX,
  defaultCashFrenzy,
  defaultBanditos,
  defaultJunesJourney,
  defaultDrimage,
  defaultGennmu,
  dynamic,
  defaultCashmanCasino,
  defaultLightningLinkCasino,
  defaultHeartOfVegas,
  defaultCandyCrush,
  defaultBeachbum,
  defaultCookingMadness,
  defaultKonamiSlots
};

export const promotionDesignsByTheme: Record<
  EThemes,
  PromotionDesignsMetadata[]
> = Object.values(promotionDesigns).reduce(
  (acc, design) => {
    if (!acc[design.theme]) {
      acc[design.theme] = [];
    }
    acc[design.theme].push(design);
    return acc;
  },
  {} as Record<EThemes, PromotionDesignsMetadata[]>
);

export const promotionDesignsById: Record<string, PromotionDesignsMetadata> =
  Object.values(promotionDesigns).reduce(
    (acc, design) => {
      acc[design.id as string] = design;
      return acc;
    },
    {} as Record<string, PromotionDesignsMetadata>
  );
